import React, { useEffect } from 'react'
import { useSelectionStoreManager } from 'context/HomeStore/Manager/SelectionProvider/SelectionProvider.manager'
import PulsedIcons from './components/PulsedIcons'
import { UserIcon } from 'asterX-UI/Icons'
import Queue from './components/Queue'
import { WARNING_COLORS } from 'asterX-UI'
import { LoaderBackdrop } from 'asterX-UI/Loaders'
import useSeoApis from 'hooks/useSeoApis'
import { Button, Grid } from '@material-ui/core'
import { useSnackbar } from 'notistack'
import { useAuthStore } from 'context/AuthStore'
import { MANAGER_AUTO_DAMU } from 'constants/roles'

const SelectionTab = () => {
  const { enqueueSnackbar } = useSnackbar()
  const {
    authStore: { user }
  } = useAuthStore()
  const {
    selectionStore: { status, queue, loading, seoActive },
    selectionStoreFunc: {
      getSeoQueue,
      getStatus,
      haveActiveSale,
      getActiveSeo,
      goToNewWl
    }
  } = useSelectionStoreManager()
  const userRole = user.role
  const { closeTicket, startTicket, ticketLoading } = useSeoApis()

  const handleCloseTicket = async () => {
    await startTicket({
      onSuccess: () => {}
    })
    await closeTicket({
      onSuccess: ({ data }) => {
        enqueueSnackbar(data.message, { variant: 'success' })
        refreshData()
      }
    })
  }

  useEffect(() => {
    refreshData()

    const interval = setInterval(() => {
      haveActiveSale()
      if (userRole !== MANAGER_AUTO_DAMU) {
        getActiveSeo()
      }
    }, 10000)
    return () => clearInterval(interval)
  }, [])

  const refreshData = () => {
    if (userRole !== MANAGER_AUTO_DAMU) {
      getActiveSeo()
    }
    haveActiveSale()
    if (seoActive) {
      getSeoQueue()
      getStatus()
    }
  }

  const getUi = () => {
    if (!seoActive) {
      return (
        <>
          {userRole !== MANAGER_AUTO_DAMU && (
            <PulsedIcons label={status?.message} color={WARNING_COLORS}>
              <div style={{ fontSize: 34 }}>SEO не работает</div>
            </PulsedIcons>
          )}
          <Grid
            item
            xs={6}
            sm={6}
            md={6}
            style={{
              margin: '0 auto',
              height: '60vh',
              position: 'absolute',
              left: '50%',
              transform: 'translateX(-50%)',
              top: '65%'
            }}
          >
            <Button
              variant={'contained'}
              color={'primary'}
              fullWidth
              onClick={goToNewWl}
            >
              Создать РЛ
            </Button>
          </Grid>
        </>
      )
    }

    if (status?.TicketNum) {
      return (
        <>
          <PulsedIcons label={status?.message} color={WARNING_COLORS}>
            <div style={{ fontSize: 34 }}>{status?.TicketNum}</div>
          </PulsedIcons>
          <Grid
            item
            xs={6}
            sm={6}
            md={6}
            style={{
              margin: '0 auto',
              height: '70vh',
              position: 'absolute',
              left: '50%',
              transform: 'translateX(-50%)',
              top: '65%'
            }}
          >
            <Button
              disabled={ticketLoading}
              variant={'outlined'}
              color={'primary'}
              fullWidth
              onClick={handleCloseTicket}
            >
              Закрыть талон
            </Button>
            <Button
              disabled={ticketLoading}
              variant={'contained'}
              color={'primary'}
              fullWidth
              onClick={refreshData}
            >
              Обновить очередь
            </Button>
          </Grid>
        </>
      )
    }

    if (queue === 0) {
      return (
        <>
          <PulsedIcons label={'Клиентов в очереди пока нет'}>
            <UserIcon style={{ fontSize: 34 }} />
          </PulsedIcons>
          <Grid
            item
            xs={6}
            sm={6}
            md={6}
            style={{
              margin: '0 auto',
              height: '70vh',
              position: 'absolute',
              left: '50%',
              transform: 'translateX(-50%)',
              top: '65%'
            }}
          >
            <Button
              disabled={ticketLoading}
              variant={'outlined'}
              color={'primary'}
              fullWidth
              onClick={refreshData}
            >
              Обновить очередь
            </Button>
          </Grid>
        </>
      )
    }

    return <Queue />
  }

  return (
    <div>
      <LoaderBackdrop loading={loading} />
      <div style={{ position: 'relative', height: '70vh' }}>{getUi()}</div>
    </div>
  )
}
export default SelectionTab
